import React from 'react'

export const api_base = "http://localhost:8000" //API DE BASE A MODIFIER AU DEPLOIEMENT
export const api = api_base+"/api"
export const urlCandidate = "mira-lenta"
export const urlRecruiter = "mira-recruteur"
export const urlTrainer = "mira-formateur"
export const PATH_END_POINT = api_base+"/storage"

